import React, { useState } from 'react';

const MapContext = React.createContext();

export const MapContextProvider = ({ children }) => {
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <MapContext.Provider
      value={{ selectedProject: selectedProject, setSelectedProject }}
    >
      {children}
    </MapContext.Provider>
  );
};

export const MapContextConsumer = MapContext.Consumer;

export default MapContext;
